import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import TimeSlotEntry from '../TimeSlotEntry';
import Spinner from '../../../../../../components/Spinner';

import './SelectWrap.scss';

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

const DayIndex = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const MonthIndex = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const MeetingOffset = 15; // Mins

class DayInitialiser extends React.Component {
  constructor(props) {
    super(props);

    console.log(props);

    const MeetingLength = props.data.ModuleInstance.module.duration_minutes; // Mins

    const { NegativeTimes, PositiveTimes } = props.data.getAdvisorScheduleNodes.reduce((sum, ScheduleNode) => { // Sort Nodes into a positive and a negative array
      const SortKey = (ScheduleNode.negative_positive === 1) ? 'PositiveTimes' : 'NegativeTimes';

      return {
        ...sum,
        [SortKey]: [
          ...sum[SortKey],
          ScheduleNode
        ]
      };
    }, { NegativeTimes: [], PositiveTimes: [] });

    const ParseNodesSegments = (NodeArray, Value) => NodeArray.reduce((sum, ScheduleNode) => { // Takes the segment and determines the starting points within
      const SegmentLength = ScheduleNode.end_timestamp - ScheduleNode.start_timestamp;
      let CurrentOffset = 0;
      const NewTimes = {
        [ScheduleNode.end_timestamp]: true,
      };

      while (ScheduleNode.start_timestamp + CurrentOffset <= (ScheduleNode.end_timestamp - (MeetingOffset * 60))) {
        const NewOffset = ScheduleNode.start_timestamp + CurrentOffset;
        CurrentOffset += 15 * 60;
        NewTimes[NewOffset] = Value;
      }

      return {
        ...sum,
        ...NewTimes,
      };
    }, {});

    const Times = { // Combine the positive and negative segments with preference to negative
      ...ParseNodesSegments(PositiveTimes, true),
      ...ParseNodesSegments(NegativeTimes, false),
    };

    const FinalAvailableTimes = Object.keys(Times).filter(TimeStamp => {
      if (Times[TimeStamp] !== true || ((TimeStamp * 1000) - Date.now()) < 28800000) {
        return false;
      }

      let Available = true;
      let Offset = 0;
      const TimeInt = parseInt(TimeStamp);

      while ((TimeInt + Offset) <= TimeInt + (MeetingLength * 60)) {
        if (Times[(TimeInt + Offset)] !== true) {
          Available = false;
        }

        Offset += MeetingOffset * 60;
      }

      return Available;
    }); // Get all available starting points
    FinalAvailableTimes.sort();

    const DaySorted = FinalAvailableTimes.reduce((sum, Time) => { // Categorise Starting points by day
      const DateObject = new Date(Time * 1000);
      const Key = [DateObject.getUTCFullYear(), ('0' + (DateObject.getMonth() + 1)).slice(-2), DateObject.getDate()].join('/');

      return {
        ...sum,
        [Key]: [
          ...(sum[Key] || []),
          {
            Time: DateObject,
            TimeStamp: Time,
          }
        ]
      };

      return sum;
    }, {});

    this.state = {
      dayCurrentlySelected: null,
      DaysAvailable: DaySorted,
      timeDisplay24Hour: false,
      timeToConfirm: null,
      loading: false,
      MeetingLength: MeetingLength, // Minutes
      Error: null,
      Successful: null,
    };

    if (props.authedUserID !== props.data.ModuleInstance.student.id) {
      this.state.Error = 'This is not your session';
    }

    if (props.data.ModuleInstance.scheduled_to !== null) {
      this.state.Error = 'This session is already scheduled';
    }

    this.SelectDayEntry = this.SelectDayEntry.bind(this);
    this.handleTimeSlotSelect = this.handleTimeSlotSelect.bind(this);
    this.handleTimeSelectConfirm = this.handleTimeSelectConfirm.bind(this);
    this.handleTimeRejection = this.handleTimeRejection.bind(this);
  }

  SelectDayEntry(index) {
    return event => { // Toggle Day
      this.setState({
        dayCurrentlySelected: index,
        timeToConfirm: null,
      });
    };
  }

  handleTimeSlotSelect(id) {
    return () => {
      console.log(id);
      this.setState({
        timeToConfirm: id,
      });
    };
  }

  handleTimeSelectConfirm(id) {
    return () => {
      this.setState({
        loading: true
      });
      console.log('Confirmed Time: ', id);
      this.props.ScheduleTime({
        variables: {
          ModuleInstanceID: this.props.routeParams.ModuleInstance,
          Epoch: id,
        },
      })
        .then(() => {
          this.setState({
            loading: false,
            Successful: 'Woohoo! The session was scheduled successfully.'
          });
        })
        .catch(err => {
          console.log(err);
          this.setState({
            loading: false
          });
        });
    };
  }

  handleTimeRejection() {
    this.setState({
      loading: true
    });

    this.props.RequestMoreTime({
      variables: {
        ModuleInstanceID: this.props.routeParams.ModuleInstance,
      },
    })
      .then(() => {
        this.setState({
          loading: false,
          Successful: 'Your request for more time slots has been received. We will ask the advisor to provide more available times. Our advisors are busy professionals so, hopefully they are able to!'
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false
        });
      });
  }

  render() {
    const ModuleInstance = this.props.data.ModuleInstance;
    const Advisor = this.props.data.ModuleInstance.advisor;

    const getTimeZone = () => {
      let ReturnString = 'UTC' + ((new Date().getTimezoneOffset() > 0) ? '-' : '+') + Math.abs((new Date().getTimezoneOffset() / 60));

      if (typeof Intl !== 'undefined') { // Older browsers do not support localised Timezones
        ReturnString = Intl.DateTimeFormat().resolvedOptions().timeZone + ' (' + ReturnString + ')'
      }

      return ReturnString;
    }

    if (this.state.Error !== null) {
      return (
        <p style={{ color: 'red', textAlign: 'center', paddingTop: '20px' }}>{this.state.Error}</p>
      );
    }

    if (this.state.Successful !== null) {
      return (
        <p style={{ color: 'green', textAlign: 'center', paddingTop: '20px' }}>{this.state.Successful}</p>
      );
    }

    if (this.state.loading === false) {
      return (
        <div className='container'>
          <div className='SelectWrap'>
            <div className='ModuleHeader__Segment'>
              <div className='row'>
                <div className='col-sm-6'>
                  <h3 className='ModuleHeader__Header'>
                    {ModuleInstance.module.module_name}
                  </h3>
                  <h3 className='ModuleHeader__SubHeader'>{((ModuleInstance.Industry !== null) ? ModuleInstance.Industry.name : null)}</h3>
                </div>
                <div className='col-sm-6'>
                  <div className='IdentityWrapper'>
                    <div className='row'>
                      <div className='col-4'>
                        <div className='IdentityWrapper__ImageWrapper'>
                          {(Advisor.photo !== null) ? <img src={IMAGECACHELINK + '/' + IMAGESTAGE + '/125x125/' + Advisor.photo} /> : null}
                        </div>
                      </div>
                      <div className='col-7'>
                        <p>
                          <b>Advisor </b>
                          {Advisor.first_name + ' ' + Advisor.last_name}
                        </p>
                        <p><b>Your Timezone: </b>{getTimeZone()}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <h2>Select a Day</h2>
            <div className='SelectWrap__Header clearfix'>
              {Object.keys(this.state.DaysAvailable).slice(0, 5).map((Key, Index) => {
                const DateObject = new Date(Key);

                return (
                  <div style={{ width: '20%', float: 'left' }} key={Key}>
                    <div className={classnames({
                      'SelectWrap__DayEntry': true,
                      'SelectWrap__DayEntry--Selected': Key === this.state.dayCurrentlySelected,
                    })}>
                      <div onClick={this.SelectDayEntry(Key)} className='SelectWrap__DayEntryInternal'>
                        <p>
                          {DayIndex[DateObject.getDay()].slice(0, 3)}
                          <br />
                          {DateObject.getDate() + ' ' + MonthIndex[DateObject.getMonth()]}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className='SelectWrap__Wrapper'>
              <h2>Then select a time</h2>
              {(this.state.DaysAvailable[this.state.dayCurrentlySelected] || []).map((val, index) => {
                return (
                  <TimeSlotEntry key={'TimeSlotEntry__' + index} select={this.handleTimeSlotSelect} confirm={this.state.timeToConfirm === parseInt(val.TimeStamp)}
                    StartTime={parseInt(val.TimeStamp)} display24Hour={this.state.timeDisplay24Hour} onChange={this.handleTimeSelectConfirm}
                    meetingLength={this.state.MeetingLength} key={index} />
                );
              })}
              <br />
              <h2>Or if none of these times work</h2>
              <div className='NoOptions--Btn' onClick={this.handleTimeRejection}>I am not available on any of these days or times</div>
              <br />
            </div>
          </div>
        </div>
      );
    }

    return (
      <Spinner />
    );
  }
}

export default connect(mapStateToProps)(DayInitialiser);



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/SelectSlot/components/SelectWrap/index.js